import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";

export const TypeAheadService = {
  getTypeAhead(prefix: string) {
    return HttpClient.post({
      baseUri: ApiEndpointResolver.getTypeAheadUrl(),
      body: {
        inputString: prefix,
      },
    });
  },
};
